(function () {
  var PREVIEW_W = 550;
  var PREVIEW_H = 734;
  var ZOOM_MIN = 0.4;
  var ZOOM_MAX = 2.5;
  var ZOOM_STEP = 0.02;
  var EXPORT_VERSION = 1;

  var COLOR_RANK = [
    { re: /chocolate/i, rank: 4 },
    { re: /taupe/i, rank: 3 },
    { re: /malbec/i, rank: 2 },
  ];

  /** @type {Array<any>} */
  var stateEntries = [];
  var proc = null;

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function clamp(n, a, b) {
    return Math.max(a, Math.min(b, n));
  }

  function colorRank(item) {
    var hay = (item.handle + ' ' + item.title + ' ' + (item.cor || '')).toLowerCase();
    var i;
    for (i = 0; i < COLOR_RANK.length; i++) {
      if (COLOR_RANK[i].re.test(hay)) return COLOR_RANK[i].rank;
    }
    return 1;
  }

  function resolveModelos(products, catalog) {
    var byId = {};
    var byHandle = {};
    (catalog || []).forEach(function (m) {
      if (m.id != null && m.id !== '') byId[String(m.id)] = m;
      if (m.handle) byHandle[m.handle] = m;
    });

    products.forEach(function (p) {
      var meta = null;
      if (p.modeloId && byId[String(p.modeloId)]) meta = byId[String(p.modeloId)];
      else if (p.modelo && byHandle[p.modelo]) meta = byHandle[p.modelo];
      if (meta) {
        p.modelo = meta.handle || p.modelo;
        p.modeloLabel = meta.nome || meta.handle || p.modelo;
      } else if (p.modelo) {
        p.modeloLabel = p.modelo.replace(/-/g, ' ');
      } else {
        p.modelo = '';
        p.modeloLabel = '';
      }
    });
  }

  function pickRepresentatives(products) {
    var groups = Object.create(null);
    products.forEach(function (p) {
      if (!p.modelo || !p.mainUrlHi) return;
      if (!groups[p.modelo]) groups[p.modelo] = [];
      groups[p.modelo].push(p);
    });

    return Object.keys(groups)
      .sort(function (a, b) {
        var la = (groups[a][0] && groups[a][0].modeloLabel) || a;
        var lb = (groups[b][0] && groups[b][0].modeloLabel) || b;
        return la.localeCompare(lb, 'pt-BR');
      })
      .map(function (modelo) {
        var items = groups[modelo].slice().sort(function (a, b) {
          if (!!a.draft !== !!b.draft) return a.draft ? 1 : -1;
          var dr = colorRank(b) - colorRank(a);
          if (dr !== 0) return dr;
          return a.handle.localeCompare(b.handle);
        });
        return {
          modelo: modelo,
          label: items[0].modeloLabel || modelo,
          product: items[0],
        };
      });
  }

  function srcBadge(product) {
    if (!product.srcW || !product.srcH) return '—';
    return product.srcW + '×' + product.srcH;
  }

  function profileKey(profile) {
    if (!profile) return 'default';
    var keys = Object.keys(proc.REF_PROFILES || {});
    var i;
    for (i = 0; i < keys.length; i++) {
      if (proc.REF_PROFILES[keys[i]] === profile) return keys[i];
    }
    return profile.label || 'default';
  }

  function renderPreview(entry) {
    var item = entry.pipelineItem;
    var canvas = proc.processTo34(
      item,
      entry.baseScale,
      entry.profile.bottomGap,
      proc.defaultProcessOpts(),
      PREVIEW_W,
      PREVIEW_H,
    );
    return canvas.toDataURL('image/jpeg', 0.9);
  }

  function updatePreview(entry) {
    if (!entry.imgEl) return;
    entry.imgEl.src = renderPreview(entry);
    if (entry.zoomValEl) {
      entry.zoomValEl.textContent = Math.round(entry.pipelineItem.edit.scaleMul * 100) + '%';
    }
    if (entry.zoomMinusEl) {
      entry.zoomMinusEl.disabled = entry.pipelineItem.edit.scaleMul <= ZOOM_MIN + 0.001;
    }
    if (entry.zoomPlusEl) {
      entry.zoomPlusEl.disabled = entry.pipelineItem.edit.scaleMul >= ZOOM_MAX - 0.001;
    }
  }

  function setZoom(entry, scaleMul) {
    entry.pipelineItem.edit.scaleMul = clamp(scaleMul, ZOOM_MIN, ZOOM_MAX);
    updatePreview(entry);
  }

  function nudgeZoom(entry, delta) {
    setZoom(entry, entry.pipelineItem.edit.scaleMul + delta);
  }

  function buildExportPayload() {
    return {
      version: EXPORT_VERSION,
      exportedAt: new Date().toISOString(),
      canvas: { width: proc.OUT_W, height: proc.OUT_H },
      bottomGapDefault: proc.DEFAULT_BOTTOM,
      preview: { width: PREVIEW_W, height: PREVIEW_H },
      entries: stateEntries.filter(Boolean).map(function (entry) {
        var p = entry.product;
        var edit = entry.pipelineItem.edit;
        return {
          modelo: entry.modelo,
          modeloLabel: entry.label,
          referenceHandle: p.handle,
          referenceTitle: p.title,
          srcW: p.srcW || null,
          srcH: p.srcH || null,
          profile: profileKey(entry.profile),
          contentH: entry.profile.contentH,
          bottomGap: entry.profile.bottomGap,
          baseScale: Number(entry.baseScale.toFixed(6)),
          scaleMul: Number(edit.scaleMul.toFixed(4)),
          offsetX: edit.offsetX || 0,
          offsetY: edit.offsetY || 0,
        };
      }),
    };
  }

  function downloadJson() {
    var payload = buildExportPayload();
    var blob = new Blob([JSON.stringify(payload, null, 2)], { type: 'application/json' });
    var url = URL.createObjectURL(blob);
    var a = document.createElement('a');
    var stamp = new Date().toISOString().slice(0, 19).replace(/[:T]/g, '-');
    a.href = url;
    a.download = 'gm-fotos-referencia-' + stamp + '.json';
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(url);
  }

  function buildCard(entry) {
    var p = entry.product;
    var card = document.createElement('article');
    card.className = 'gm-ajuda-ref__card';
    card.dataset.modelo = entry.modelo;

    var media = document.createElement('div');
    media.className = 'gm-ajuda-ref__media';

    var img = document.createElement('img');
    img.alt = '';
    img.loading = 'lazy';
    img.decoding = 'async';
    media.appendChild(img);

    var badge = document.createElement('span');
    badge.className = 'gm-ajuda-ref__badge';
    badge.textContent = srcBadge(p) + ' → 1650×2200';
    media.appendChild(badge);

    var zoom = document.createElement('div');
    zoom.className = 'gm-ajuda-ref__zoom';

    var btnMinus = document.createElement('button');
    btnMinus.type = 'button';
    btnMinus.className = 'gm-ajuda-ref__zoom-btn';
    btnMinus.setAttribute('aria-label', 'Diminuir');
    btnMinus.textContent = '−';

    var zoomVal = document.createElement('span');
    zoomVal.className = 'gm-ajuda-ref__zoom-val';

    var btnPlus = document.createElement('button');
    btnPlus.type = 'button';
    btnPlus.className = 'gm-ajuda-ref__zoom-btn';
    btnPlus.setAttribute('aria-label', 'Aumentar');
    btnPlus.textContent = '+';

    zoom.appendChild(btnMinus);
    zoom.appendChild(zoomVal);
    zoom.appendChild(btnPlus);

    var foot = document.createElement('div');
    foot.className = 'gm-ajuda-ref__foot';

    var modeloEl = document.createElement('p');
    modeloEl.className = 'gm-ajuda-ref__modelo';
    modeloEl.textContent = entry.label;

    var handleEl = document.createElement('p');
    handleEl.className = 'gm-ajuda-ref__handle';
    var handleLink = document.createElement('a');
    handleLink.href = p.url;
    handleLink.textContent = p.handle + (p.draft ? ' · rascunho' : '');
    handleEl.appendChild(handleLink);

    foot.appendChild(modeloEl);
    foot.appendChild(handleEl);

    card.appendChild(media);
    card.appendChild(zoom);
    card.appendChild(foot);

    entry.imgEl = img;
    entry.zoomValEl = zoomVal;
    entry.zoomMinusEl = btnMinus;
    entry.zoomPlusEl = btnPlus;

    btnMinus.addEventListener('click', function () {
      nudgeZoom(entry, -ZOOM_STEP);
    });
    btnPlus.addEventListener('click', function () {
      nudgeZoom(entry, ZOOM_STEP);
    });

    updatePreview(entry);
    return card;
  }

  function buildPlaceholder(entry) {
    var card = document.createElement('article');
    card.className = 'gm-ajuda-ref__card';
    card.innerHTML =
      '<div class="gm-ajuda-ref__media" style="display:grid;place-items:center;background:var(--gm-surface);font:400 12px/1.3 var(--gm-font-body);color:var(--gm-text-muted)">…</div>' +
      '<div class="gm-ajuda-ref__zoom"></div>' +
      '<div class="gm-ajuda-ref__foot"><p class="gm-ajuda-ref__modelo">' +
      esc(entry.label) +
      '</p><p class="gm-ajuda-ref__handle">' +
      esc(entry.product.handle) +
      '</p></div>';
    return card;
  }

  async function prepareEntry(entry) {
    var p = entry.product;
    var pipelineItem = {
      id: p.handle,
      modelo: p.modelo,
      analysis: null,
      edit: { scaleMul: 1, offsetX: 0, offsetY: 0, bboxOverride: null },
    };
    var img = await proc.loadImage(p.mainUrlHi);
    pipelineItem.analysis = proc.analyzeImage(img);
    var processed = proc.processItem(pipelineItem, PREVIEW_W, PREVIEW_H);
    entry.pipelineItem = pipelineItem;
    entry.profile = processed.profile;
    entry.baseScale = processed.baseScale;
    return entry;
  }

  async function init() {
    var section = document.querySelector('.gm-ajuda-ref');
    if (!section) return;

    var grid = section.querySelector('[data-gm-ajuda-ref-grid]');
    var productsEl = section.querySelector('[data-gm-ajuda-ref-products]');
    var modelosEl = section.querySelector('[data-gm-ajuda-ref-modelos]');
    var exportBtn = section.querySelector('[data-gm-ajuda-ref-export]');
    if (!grid || !productsEl) return;

    proc = window.GmMainPhotoProcess;
    if (!proc) {
      grid.innerHTML = '<p class="gm-ajuda-ref__status">Pipeline indisponível.</p>';
      return;
    }

    var products;
    var catalog = [];
    try {
      products = JSON.parse(productsEl.textContent || '[]');
      if (modelosEl) catalog = JSON.parse(modelosEl.textContent || '[]');
    } catch (err) {
      grid.innerHTML = '<p class="gm-ajuda-ref__status">Erro ao carregar dados.</p>';
      return;
    }

    if (window.GmPhotoCatalog) {
      var catalogRows = await window.GmPhotoCatalog.load();
      products = window.GmPhotoCatalog.merge(products, catalogRows, window.GmPhotoCatalog.mapRef);
    }

    resolveModelos(products, catalog);
    var reps = pickRepresentatives(products);
    if (!reps.length) {
      grid.innerHTML = '<p class="gm-ajuda-ref__status">Nenhum modelo com foto.</p>';
      return;
    }

    grid.innerHTML = '';
    stateEntries = new Array(reps.length);

    reps.forEach(function (entry, index) {
      grid.appendChild(buildPlaceholder(entry));
    });

    var ready = 0;

    function checkExportReady() {
      if (!exportBtn) return;
      var loaded = stateEntries.filter(Boolean).length;
      exportBtn.disabled = loaded !== reps.length;
    }

    reps.forEach(function (entry, index) {
      prepareEntry(entry)
        .then(function (readyEntry) {
          stateEntries[index] = readyEntry;
          var card = buildCard(readyEntry);
          var placeholder = grid.children[index];
          if (placeholder) grid.replaceChild(card, placeholder);
          ready += 1;
          checkExportReady();
        })
        .catch(function () {
          var placeholder = grid.children[index];
          if (!placeholder) return;
          placeholder.classList.add('is-error');
          var media = placeholder.querySelector('.gm-ajuda-ref__media');
          if (media) media.textContent = 'Erro';
          ready += 1;
          checkExportReady();
        });
    });

    if (exportBtn) {
      exportBtn.addEventListener('click', function () {
        if (stateEntries.filter(Boolean).length !== stateEntries.length) return;
        downloadJson();
      });
    }
  }

  function boot() {
    if (window.GmMainPhotoProcess) {
      init();
      return;
    }
    var tries = 0;
    var timer = setInterval(function () {
      tries += 1;
      if (window.GmMainPhotoProcess || tries > 40) {
        clearInterval(timer);
        init();
      }
    }, 50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
